<template>
  <section class="buy">
    <template v-if="detail.id">
      <div class="top-notic" v-show="topNoticBtnShow">
        <div class="top-notic-van">
          <van-notice-bar left-icon="volume-o" text="春节放假通知" background="#f8f58d" color="#ff3348" />
        </div>
        <div class="top-notic-btn" @click="handleTopNoticBtn">查看详情>></div>
        <div v-if="topNoticTxtShow" class="wrapper" @click="topNoticTxtShow = false">
          <div class="block" @click.stop>
            <img class="close-btn" @click="topNoticTxtShow = false"
              src="https://res.cdn.changbaimg.com/-/bdb969efbeaa39b8/close_btn.png">
            <h2>春节放假通知</h2>
            亲爱的用户，您好！<br>
            金蹄踏福至，策马启新程。结合国家法定节假日规定与人工修音团队实际情况，我们的放假安排如下：<br><br>
            <span class="red">放假时间：2026年2月15日-2026年2月23日，共计9天。</span><br><br>
            特别提醒：<br>
            <span class="red">1.在此期间均有修音师在岗负责制作，您可正常下单购买。</span><br>
            <span>2.由于修音师为排班制，<span class="red">审核时间会相对延长，加急服务订单时效延长为24H，返工延长为72H，</span>请您耐心等待。</span><br>
            <span>3.如有问题可在10:00-19:00时段联系客服，给您带来的不便，请您谅解。</span><br><br>
            在新的一年里，我们将继续以专业的技术和高度的责任心，为您精心雕琢每一个音频细节，让您的作品如骏马奔腾，声入人心！期待与您共创更多美妙的音乐作品～<br><br>
            感谢您对唱吧人工修音一直以来的信赖和支持，祝大家新春策马逐梦，驰骋安康坦途！<br><br>
            <span class="right">唱吧人工修音团队</span><br>
            <span class="right">2026年2月</span>
          </div>
        </div>
      </div>
      <section class="header">
        <media>
          <template #left>
            <div class="pic" v-if="detail.other_attribute">
              <img :src="detail.other_attribute.icon" v-if="detail.other_attribute.icon" alt="">
            </div>
          </template>
          <template #body>
            <h2><span>{{ detail.name }}</span></h2>
            <p>
              <span class="price">¥{{ detail.now_money }}</span><template v-if="detail.service_class == 1">/首</template>
            </p>
          </template>
          <template #right>
            <button type="button" class="change-product" @click="openProductPicker">更换</button>
          </template>
        </media>

        <div class="bd" v-if="detail.service_class == 1 && detail.type == 3">
          <ul class="timeline">
            <li class="active">
              <div class="timeline-item">
                <p>缴纳定金先制作</p>
                <p>¥{{ firstPrice }}</p>
              </div>
            </li>
            <li>
              <div class="timeline-item">
                <p>
                  成品满意付尾款<br>
                  <small>(如有优惠，所含优惠在尾款中使用)</small>
                </p>
                <p>¥{{ finalPrice }}</p>
              </div>
            </li>
          </ul>
        </div>

        <div class="ft">
          <div class="text">平台保障</div>
          <div class="text yes" v-for="(item, index) in detail.guarantee" :key="index">{{ item.title }}</div>
        </div>
      </section>

      <section class="optional-service">
        <div class="inner flex-betweent-start" @click="selectSong" v-if="detail.service_class == 1" v-cbs="'下单页-添加歌曲'">
          <div class="bd">
            <h4>想制作的歌曲</h4>
          </div>
          <div class="ft">
            <div class="action">
              <span class="black" v-if="detail.workinfo">《{{ detail.workinfo.song_name }}》</span>
              <span v-else>待添加 &#12297;</span>
            </div>
            <div class="extra-desc">
              <p v-if="detail.workinfo"><strong>重新选择</strong></p>
              <p v-else><strong>选择你想制作的歌</strong></p>
            </div>
          </div>
        </div>
        <!-- 特殊处理id 56 加急服务 -->
        <div class="inner flex-betweent-start"
          v-if="detail.service_class == 1 && detail.type != 2 && detail.type != 3 && productId !== 55 && productId !== 56">
          <div class="bd">
            <h4>加急服务 <span class="price">￥<span>{{ detail.speedup_money }}</span></span></h4>
          </div>
          <div class="extra-option">
            <van-switch class="mall-switch" v-model="optionalService" @change="changeOptionalService" />
            <p class="speedup_tips" v-for="(item, index) in urgentTime" :key="'speedup_tips' + index">{{ item }}</p>
          </div>
          <!-- <p>{{ productId }}</p> -->
        </div>
        <!-- 特殊处理id 56 优惠折扣 -->
        <div class="inner coupon" @click="showCouponPopup" v-if="productId !== 56">
          <div class="bd">
            <h4>优惠折扣</h4>
          </div>
          <div class="ft">
            <div class="action">
              <template v-if="couponUsable > 0">
                <template v-if="selectedCoupon.id">
                  <strong>{{ selectedCoupon.title }}</strong> &#12297;
                </template>
                <template v-else>
                  {{ couponUsable }}张可用 &#12297;
                </template>
              </template>
              <template v-else>
                暂无可用
              </template>
            </div>
          </div>
        </div>
        <!-- 特殊处理id 56 活动专享-->
        <div class="inner topic flex-betweent-start" @click="showTopicPopup" v-if="productId !== 56">
          <div class="bd">
            <h4>活动专享</h4>
          </div>
          <div class="ft">
            <div class="action">
              <template v-if="topicUsable">
                <template v-if="selectedTopic.id">
                  <strong>{{ selectedTopic.name }} &#12297;</strong>
                </template>
                <template v-else>
                  请选择 &#12297;
                </template>
              </template>
              <template v-else>
                暂无可用
              </template>
            </div>
            <div class="extra-desc">
              <p>活动与优惠券不叠加</p>
            </div>
          </div>
        </div>

      </section>

      <section class="list-box">
        <ul>
          <!-- 特殊处理id 56 指定制作师-->
          <li @click="openProducer" v-if="detail.service_class == 1 && productId !== 56">
            <div class="inner flex-betweent-start">
              <div class="bd">
                <h4>指定制作师</h4>
              </div>
              <div class="flex-right">
                <div class="action" v-if="showProducer">
                  <span>
                    {{ selectedProducer.producerid
                      ?
                      selectedProducer.name_zh
                      : '选择'
                    }} &#12297;
                  </span>
                </div>
                <div class="extra-desc no-margin" v-else>
                  <p>首单不享受此权益</p>
                  <p>次单起可指定喜欢的制作师</p>
                </div>
              </div>
            </div>
          </li>

          <li @click="openNoteDialog" v-if="detail.service_class == 1">
            <div class="inner flex-betweent-start">
              <div class="bd">
                <h4>备注（填写你的修音需要）</h4>
              </div>
              <div class="flex-right">
                <div class="action">
                  <span>{{ noteOptionsDataSimpleText || '选择 &#12297;' }}</span>
                </div>
              </div>
            </div>
          </li>

          <li @click="openMobile" v-cbs="'下单页-手机号输入框-展示'">
            <div class="inner flex-betweent-start">
              <div class="bd">
                <h4>联系手机号</h4>
              </div>
              <div class="ft">
                <span class="text">{{ mobile | mask }}&nbsp;&nbsp;&#12297;</span>
                <div class="extra-desc">
                  <p>用于接收订单相关的通知短信</p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </section>
      <!-- 特殊处理id 56 支付 -->
      <section class="payment" v-if="+productId !== 56">
        <ul>
          <li v-for="(item, index) in paymentList" :class="item.type" :key="index">
            <label class="custom-control">
              <input type="radio" name="payment" :value="item.type" v-model="paymentType"
                @change="handlePaymentChange(item)">
              <div class="label">
                <div class="icon"></div>
                <div class="name">
                  <p>{{ item.name }}</p>
                  <small v-if="item.desc">{{ item.desc }}</small>
                </div>
                <div class="checkbox"></div>
              </div>
            </label>
          </li>
        </ul>
      </section>
      <!-- 特殊处理id 56 下单须知 -->
      <h4 class="outside-title" v-if="+productId !== 56">下单须知</h4>
      <!-- 特殊处理id 56 下单须知 -->
      <section class="buy-tips" v-if="+productId !== 56">
        <template v-if="detail.service_class == 1">
          <p>
            <input class="agreement-checkbox" type="checkbox" v-model="agreement[0]" />
            *退款政策：下单素材不符合修音制作条件全额退款
          </p>
          <p>
            <input class="agreement-checkbox" type="checkbox" v-model="agreement[1]" />
            *用户协议：继续操作代表您接受<a href="javascript:;" @click="showRule = true" v-cbs="`唱吧修音条款`">《唱吧修音条款》</a>
          </p>
          <mall-rule v-if="showRule" :show.sync="showRule" />
        </template>

        <template v-else-if="detail.service_class == 2">
          <p>*用户协议：继续操作代表您接受<a href="javascript:;" @click="showRule = true" v-cbs="`购买须知`">《购买须知》</a></p>
          <van-dialog v-model="showRule" title="购买须知" class="mall-dialog-rule">
            <div class="van-dialog__message van-dialog__message--has-title">
              1、您所购买的音乐教学课程将由第三方为您提供，具体的提供方信息请参见所购商品的详情页展示，或通过咨询客服进行查询。具体的服务、开具发票、售后及退款由服务提供方为您提供。如提供方为自然人，则可能无法为您提供发票，平台方作为售卖平台，非课程的提供方，不具有向您开票的义务。<br>
              2、您所购买的音乐教学课程将采用网络授课形式向您提供，您在课程开始前请务必调整好您的设备及网络，具体授课时间及授课内容您可参照商品详情页或联系服务提供方，如您因个人原因而无法参加课程的请您与服务提供方及时取得联系。<br>
              3、由于授课采用网络授课方式您须自行配备上网和使用电信增值业务所需的设备，自行负担个人上网或第三方（包括但不限于电信、移动通信服务提供商）收取的通讯费、信息费等有关费用。<br>
              4、您购买的课程未开课的，可申请全额退款。您购买的课程已开课的非平台技术原因不予退款。平台技术原因是指：由平台技术故障引发的连续超过24小时课程无法正常观看、视频无法正常播放。如因您网络原因、观看设备故障、用户账号丢失等类原因不属于平台技术故障。课程退款以订单号为单位，同一订单号中有多门课程的，不支持单门课程退款。
            </div>
          </van-dialog>
        </template>
      </section>

      <section class="footer">
        <div class="inner">
          <media>
            <template #body>
              <p v-if="detail.service_class == 1 && detail.type == 3">
                本次应付：<span class="money">¥{{ firstPrice }}</span>
              </p>
              <p v-else>
                总计：<span class="money">¥{{ totalPrice }}</span>
              </p>
            </template>
            <template #right>
              <button type="button" class="btn" @click="handleSubmit"
                v-cbs="{ name: '下单页-提交订单', product_id: productId }">提交订单</button>
            </template>
          </media>
        </div>
      </section>

      <van-popup v-model="productPicker" position="bottom">
        <van-picker show-toolbar :default-index="productPickerDefault" :columns="productPickerData"
          @cancel="productPicker = false" @confirm="switchProduct" />
      </van-popup>

      <van-dialog v-model="mobileDialog" class-name="offset-top" title="请输入手机号" show-cancel-button
        :before-close="setMobile">
        <div class="mobile-input-container">
          <input type="text" class="mobile-input" v-model.trim="tempMobile">
        </div>
      </van-dialog>

      <!-- 备注（选择修音需求）弹窗 -->
      <van-popup v-model="popupNote" closeable round position="bottom" close-icon="close" :style="{ height: '80%' }">
        <div class="mall-dialog">
          <div class="mall-dialog-body">
            <dl v-if="noteOptions">
              <template v-for="(item, key) in noteOptions">
                <dt :key="`dt-${key}`">{{ item.text }}</dt>

                <dd :key="`dd-${key}`" v-if="item.select > 1">
                  <!-- 多选 -->
                  <mall-checkbox :maxnum="item.select" v-model="noteOptionsData[key]" :lists="item.suboptions" />
                </dd>

                <dd :key="`dd-${key}`" v-else>
                  <!-- 单选 -->
                  <mall-radio :name="`note-${option}`" :value="valueIndex" v-model="noteOptionsData[key]"
                    v-for="(option, valueIndex) in item.suboptions" :key="valueIndex">
                    {{ option }}
                  </mall-radio>
                </dd>
              </template>
              <dt>其他备注</dt>
              <dd>
                <textarea placeholder="给制作师留言，告诉他你还有什么期望" v-model="otherNote"></textarea>
              </dd>
            </dl>
          </div>
          <div class="mall-dialog-footer">
            <button type="button" class="mall-dialog-button" @click="handleClickNoteConfirmBtn">确认</button>
          </div>
        </div>
      </van-popup>

      <van-popup v-model="popupCoupon" class="popup-coupon" round position="bottom" :style="{ height: '60%' }">
        <div class="coupons">
          <ul>
            <li v-for="(item, index) in coupons" :key="index" :class="{ selected: selectedCoupon.id === item.id }"
              @click="useCoupon(item)">
              <div class="hd" :class="{ disabled: item.can_use != 1 }">
                <div class="money" v-if="item.type == 1 || item.type == 2">
                  ￥<strong>{{ item.discount_money }}</strong>
                </div>
                <div class="discount" v-else-if="item.type == 3">
                  <strong>{{ item.discount_rate }}</strong>折
                </div>
                <div class="desc">{{ item.use_rule_text }}</div>
              </div>
              <div class="bd">
                <div class="title">{{ item.title }}</div>
                <div class="desc">{{ item.end_time }} 到期</div>
                <div class="normal" v-if="item.can_use != 1">
                  <span>不支持</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </van-popup>

      <!-- 选择制作师弹窗 -->
      <van-popup v-model="popupProducer" class="popup-seller" round position="bottom" :style="{ height: '60%' }">
        <div class="sellers">
          <ul>
            <template v-if="producersList && producersList.length">
              <li v-for="(item, index) in producersList" :key="index" :class="{
                selected: selectedProducer.producerid === item.producerid,
                'producer-item': true
              }
                " @click="selectProducer(item)">
                <div class="producer-item-avatar">
                  <CbImage :src="item.simpleUser.headphoto" specific />
                </div>
                <div class="producer-item-info">
                  <div class="producer-item-name">{{ item.name_zh }}</div>
                  <div class="producer-item-desc" v-if="index < 1 && item.last_select">上次为您制作</div>
                </div>
                <div class="producer-item-btn">选择</div>
              </li>
            </template>
            <template v-else>
              <li>
                <div class="empty">暂无制作师</div>
              </li>
            </template>
          </ul>
        </div>
      </van-popup>

      <van-action-sheet class="topics" v-model="popupTopic" :actions="topicActions" @select="useTopic" />

    </template>
  </section>
</template>

<script>
import { Image } from '@changba/component';
import { trackElClickH5 } from '@changba/funny';
import qs from 'qs';
import { getUrlSource } from '../changba-stats';
import MallCheckbox from '../components/Checkbox';
import Media from '../components/Media';
import MallRadio from '../components/Radio';
import MallRule from '../components/Rule';
import { gotoWebView, isHarmonyOS } from '../utils';

// 鸿蒙不显示微信支付
const getPaymentMap = () => {
  if (!isHarmonyOS()) {
    return {
      alipay: { name: '支付宝', type: 'alipay', desc: '' },
      weixin: { name: '微信', type: 'wechat', desc: '' }
    }
  }

  return {
    alipay: { name: '支付宝', type: 'alipay', desc: '' }
  }
}

const defaultPaymentMap = getPaymentMap();

export default {
  name: 'Buy',

  components: {
    Media,
    MallRadio,
    MallRule,
    MallCheckbox,
    [Image.name]: Image
  },

  filters: {
    mask(value) {
      return String(value).replace(/^(\d{3})(\d+)(\d{3})$/, '$1*****$3');
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.productId = to.query.product_id;
    this.refresh();
    next();
  },

  data() {
    return {
      detail: {
        workInfo: {},
        price: {}
      },
      product: {},

      mobile: '',
      tempMobile: '',

      productPicker: false,
      productPickerData: [],
      productPickerDefault: 0,

      mobileDialog: false,

      productId: '', // typeof string
      optionalService: false,
      popupNote: false,
      // 是否拉取过修音偏好设置选项数据
      isLoadedNoteOptions: false,
      // 修音偏好设置选项数据
      noteOptions: {},
      // 修音偏好设置选项
      noteOptionsData: {},
      otherNote: '',
      showRule: false,

      popupCoupon: false,
      coupons: [],
      couponUsable: 0,
      selectedCoupon: {},

      basePrice: 0,
      // 制作师
      popupProducer: false,
      producersList: [],
      // 选择的制作师
      selectedProducer: {},
      // 是否开放【指定制作师】选项
      showProducer: false,

      topics: [],
      popupTopic: false,
      topicActions: [],
      topicUsable: false,
      selectedTopic: {},

      paymentType: 'alipay',
      paymentMap: defaultPaymentMap,
      paymentList: [],
      showPaymentMenu: false,
      showDepositPaymentMenu: false,

      orderid: '',

      topNoticTxtShow: false,
      topNoticBtnShow: false,

      // 下单协议
      agreement: [false, false]
    }
  },

  computed: {
    // 总价
    totalPrice() {
      if (this.basePrice === '' || isNaN(Number(this.basePrice))) {
        return 0;
      }

      return this.basePrice + this.speedupPrice;
    },

    // 区分是否是本地录音
    buyType() {
      return this.$route?.query.buy_type === 'local' ? 'local' : 'work';
    },

    // 兼容传递过来的数据 ID 参数
    dataId() {
      return this.$route?.query.dataid ?? this.$route?.query.id;
    },

    // 加急
    speedupPrice() {
      return this.optionalService ? Number(this.detail.speedup_money) : 0;
    },

    // 定金
    firstPrice() {
      if (this.totalPrice === 0) {
        return 0;
      }

      return this.totalPrice - this.finalPrice;
    },

    // 尾款
    finalPrice() {
      if (this.basePrice === '' || isNaN(Number(this.basePrice))) {
        return 0;
      }

      return this.basePrice - Number(this.detail.deposit_money);
    },

    // 备注选择后显示简短文案
    noteOptionsDataSimpleText() {
      let text = ''
      const firstOptionSelectIndex = Object.values(this.noteOptionsData)?.[0];
      const firstOptionKey = Object.keys(this.noteOptionsData)?.[0];
      text = this.noteOptions[firstOptionKey]?.suboptions?.[firstOptionSelectIndex];
      return text ? text?.slice(0, 4) + '...' : '';
    }
  },

  created() {
    const time = parseInt(new Date().getTime() / 1000)
    if (time >= 1770998400 && time < 1771948800) {  //2026-02-14 00:00:00 - 2026-02-24 24:00:00
      this.topNoticBtnShow = true
    } else {
      this.topNoticBtnShow = false
    }
    this.productId = this.$route.query.product_id;
    this.refresh();

    console.log('typeof this.productId:', typeof this.productId);

    //  todo 特殊控制弹窗
    if (+this.productId === 55) {
      // Supermix备注是必填项
      this.openNoteDialog();
    }
  },

  methods: {
    handlePaymentChange(item) {
      trackElClickH5(`支付选择-${item.name}`, { money: this.detail.type == 3 ? this.detail.deposit_money : this.detail.now_money });
    },
    handleTopNoticBtn() {
      this.topNoticTxtShow = true
    },
    async getFinishedWorks() {
      const { code, data } = await this.$fetch('/api/musicService/musicmall/getOrderWorkDoneList', {
        data: {
          orderid: this.id
        }
      });

      if (code === 1) {
        this.workDoneList = data;
      }
    },

    async refresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicService/musicmall/confirmOrder', {
        data: {
          productid: this.productId,
          dataid: this.dataId,
          type: this.buyType,
          magicParam: this.$macaddress
        }
      });

      if (code === 1) {
        if (!data.id) {
          const query = { ...this.$route.query, back_musicboard: undefined };
          this.$router.replace({ path: '/', query }, () => { });

          return;
        }
        const { supportProducers, showProducer } = data;

        this.detail = data;

        this.productId = this.detail.id;
        this.mobile = this.detail.userPhone;
        this.basePrice = this.detail.now_money;
        this.urgentTime = this.detail.other_attribute.urgentTime;
        // 制作师列表
        this.producersList = supportProducers;
        // 本单是否可以选择制作师
        this.showProducer = showProducer;

        trackElClickH5('下单页-默认手机号展示');

        // 处理支付顺序
        if (this.detail.pay_select?.length) {
          const result = [];

          this.detail.pay_select.forEach((item) => {
            // 鸿蒙不显示微信支付
            if (isHarmonyOS() && item?.type === 'wechat') {
              return;
            }
            const value = this.paymentMap[item.name];
            if (!value) {
              return;
            }
            value.desc = item.descstr;
            value.name = item.nickname;
            result.push(value);
          });

          this.paymentList = result;
          this.paymentType = this.paymentList[0].type;
        }
        else {
          this.paymentList = Object.values(this.paymentMap);
        }

        console.log('paymentList', this.paymentMap, this.paymentList);

        // 复位备注数据
        this.noteOptionsData = {};

        // 复位优惠券列表
        this.coupons = [];
        this.couponUsable = 0;
        this.selectedCoupon = {};

        // 复位活动列表
        this.topics = [];
        this.topicActions = [];
        this.topicUsable = false;
        this.selectedTopic = {};

        // 先看是否有活动，因为需要根据有没有活动再来决定是否选中优惠券
        await this.getTopics();

        // 然后再看是否有优惠券
        await this.getCoupons();

        // 如果活动和优惠券都有，则判断活动和优惠券谁更优惠
        if (this.couponUsable > 0 && this.topicUsable) {
          if (this.coupons[0].final_money < this.topics[0].activity_money) {
            this.selectedCoupon = { ...this.coupons[0] };
            this.selectedTopic = {};
            this.topicActions[0].className = '';

            await this.getMoney();
          }
          else if (this.topics[0].activity_money < this.coupons[0].final_money) {
            this.selectedTopic = { ...this.topics[0] };
            this.selectedCoupon = {};

            this.topicActions[0].className = 'selected';
            this.basePrice = Number(this.selectedTopic.activity_money);
          }
        }
      }

      this.$toast.clear();
    },

    async getNote() {
      const noteOptionsKeys = Object.keys(this.noteOptions);
      console.log({ noteOptionsKeys });
      console.log('isLoadedNoteOptions', this.isLoadedNoteOptions);
      if (noteOptionsKeys.length || this.isLoadedNoteOptions) {
        return;
      }

      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicService/musicmall/getAgainSuggestion', {
        data: {
          productType: this.detail.type,
          productid: this.productId
        }
      });

      this.$toast.clear();

      if (code === 1) {
        const { note } = data;
        this.noteOptions = note;
        this.isLoadedNoteOptions = true;
        // 设置修音偏好设置默认值，默认选择第一个
        const initOptionsData = Object.keys(note).reduce((total, current) => {
          total[current] = 0;
          return total;
        }, {});
        this.noteOptionsData = initOptionsData;
      }
    },

    async getCoupons() {
      const { code, data } = await this.$fetch('/api/musicService/musicmall/getUserCouponListByProduct', {
        data: {
          productid: this.productId
        }
      });

      if (code === 1) {
        this.coupons = data;

        this.couponUsable = this.coupons.reduce((accumulator, item) => accumulator + (item.can_use == 0 ? 0 : 1), 0);

        if (this.couponUsable > 0 && !this.selectedTopic.id) {
          this.selectedCoupon = { ...this.coupons[0] };

          await this.getMoney();
        }
      }
    },

    async getProducts() {
      if (this.productPickerData.length) {
        return;
      }

      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicService/musicmall/getProductList');

      this.$toast.clear();

      if (code === 1) {
        const allProducts = data;
        const products = [];

        this.productPickerDefault = 0;

        allProducts.forEach((item, index) => {

          products.push({
            id: item.info.id,
            text: item.info.name
          });

          if (item.info.id == this.productId) {
            this.productPickerDefault = index;
          }
        });

        this.productPickerData = products;
      }
    },

    // 提交订单
    async handleSubmit() {
      // 校验勾选下单协议
      if (+this.productId !== 56 && (!this.agreement[0] || !this.agreement[1])) {
        this.$toast({
          message: '请同意并勾选下单须知中的协议',
          duration: 2000
        })
        return
      }
      // 只有 1 品类才需要检查歌曲
      if (this.detail.service_class == 1 && !this.dataId) {
        this.$toast.fail('请先选择歌曲');
        trackElClickH5('下单页-提交失败-未选择歌曲');

        return;
      }

      if (this.mobile && !/^\d{11}$/.test(this.mobile)) {
        this.$toast.fail('请输入正确的手机号');
        trackElClickH5('下单页-提交失败-手机号格式不正确');

        return;
      }

      if (!Object.keys(this.noteOptionsData).length && +this.productId === 55) {
        console.log('Supermix备注是必填项');
        // Supermix备注是必填项
        const warmToast = () => {
          this.$toast({
            message: '请选择混音效果',
            duration: 2000
          })
        }
        this.openNoteDialog(warmToast);
        return;
      }

      if (this.mobile) {
        trackElClickH5('下单页-有填写手机号');
      }

      if (this.otherNote) {
        trackElClickH5('下单页-有填写备注');
      }

      this.$toast.loading();

      if (this.productId == 4) {
        const { code, data } = await this.$fetch('/api/activity/onePenny/checkUser');

        if (code != 1 || data.status != 1) {
          this.$toast.clear();

          this.$dialog.alert({
            title: '很遗憾，你没有抢到',
            message: '你可以去购买完整修音服务，直接获得最好的修音体验，让你的声音惊艳全场！',
            confirmButtonText: '去看看',
            beforeClose: (action, done) => {
              this.$router.push(`/product/3`);
              done();
            }
          });

          return;
        }
      }

      const { code, data, msg } = await this.$fetch('/api/musicService/musicmall/createOrder', {
        method: 'post',
        data: {
          dataid: this.dataId,
          productid: this.productId,
          phone: this.mobile,
          type: this.buyType,
          isspeed: this.optionalService ? 'yes' : 'no',
          note: JSON.stringify(this.noteOptionsData),
          desc: this.otherNote,
          couponid: this.selectedCoupon.id,
          source: getUrlSource() || 'web',
          hotuserid: this.$route.query.star_userid,
          producerid: this.selectedProducer.producerid,
          activityPriceId: this.selectedTopic.id,
          // 是否定金模式 type = 3 是定金小品类
          is_deposit: this.detail.type == 3 ? 'yes' : 'no',
          magicParam: this.$macaddress
        }
      });

      this.$toast.clear();

      if (code === 1) {

        //  特殊处理id 56
        if (this.productId == 56) {
          this.$router.push(`/order/${data}`);
          return
        }

        if (this.productId == 4) {
          await this.$fetch('/api/activity/onePenny/buyInfo', {
            method: 'post'
          });
        }

        this.orderid = data;

        trackElClickH5('下单成功', { orderid: data });

        this.$toast.success('提交成功');

        if (this.detail.service_class == 1 && this.detail.type == 3) {
          this.handlePaymentDeposit()
        }
        else {
          this.payment()
        }
        //取消支付
        // this.$router.push(`/order/${data}`);
      }
      else if (code == -13) {  //迷你修音创建失败，有未支付订单
        this.$dialog.alert({
          message: msg,
          beforeClose: (action, done) => {
            this.$router.push(`/orders`);
            done()
          }
        });
        trackElClickH5('下单页-提交失败-接口返回失败（迷你修音创建失败）');
      }
      else {
        this.$toast.fail(msg);
        trackElClickH5('下单页-提交失败-接口返回失败');
      }
    },

    // 普通支付
    async payment() {
      this.$toast.loading();

      const { code, data, msg } = await this.$fetch('/api/musicService/musicmall/payOrder', {
        method: 'post',
        data: {
          paytype: this.paymentType,
          orderid: this.orderid
        }
      });

      this.$toast.clear();

      if (code === 1) {
        // this.$toast.fail(data);
        // window.location.href = data;

        gotoWebView(data, this.$router, true)
      }
      else {
        this.$toast.fail(msg);
      }
    },

    // 定金支付
    handlePaymentDeposit() {
      this.paymentDeposit(this.paymentType);
    },

    // 定金支付
    async paymentDeposit(paymentType, final = 'no') {
      this.$toast.loading();

      const { code, data, msg } = await this.$fetch('/api/musicService/musicmall/payOrderDeposit', {
        method: 'post',
        data: {
          paytype: paymentType,
          orderid: this.orderid,
          is_final: final
        }
      });

      this.$toast.clear();

      if (code === 1) {
        // this.$toast.fail(data);
        // window.location.href = data;
        gotoWebView(data, this.$router, true)
      }
      else {
        this.$toast.fail(msg);
      }
    },

    switchProduct(item) {
      trackElClickH5('下单页-更换服务', { product_id: item.id });

      this.productPicker = false;

      const query = { ...this.$route.query };

      query.product_id = item.id;

      this.$router.replace({ path: '/buy', query }, () => { });
      // 复位备注和选项数据
      this.noteOptions = {};
      this.noteOptionsData = {};
      this.isLoadedNoteOptions = false;
    },

    selectSong() {
      const baseUrl = `${window.location.protocol}//${window.location.host}${this.$router.options.base}`;
      const params = qs.stringify({
        product_id: this.productId,
        star_userid: this.$route.query.star_userid
      });
      const redirectUrl = `${baseUrl}/buy?${params}`;

      // mediatype 表示音频或视频，0: 音频，1: 视频
      window.location = `changba://?ac=manual_correct_music&mediatype=${this.detail.type == 1 ? 1 : 0}&redirecturl=${encodeURIComponent(redirectUrl)}&source=web`;
    },

    async openMobile() {
      this.mobileDialog = true;
      this.tempMobile = this.mobile;
    },

    setMobile(action, done) {
      if (action !== 'confirm') {
        trackElClickH5('下单页-手机号输入框-关闭');
        done();
        return;
      }

      trackElClickH5('下单页-手机号输入框-确认');

      if (this.tempMobile && !/^\d{11}$/.test(this.tempMobile)) {
        this.$toast.fail('请输入正确的手机号');
        done(false);
        return;
      }

      this.mobile = this.tempMobile;
      done();
    },

    openNoteDialog(customToastFunc) {
      this.popupNote = true;

      // 解决 loading 被 popup 盖住的问题（后弹出的永远会遮住先弹出的）
      this.$nextTick(() => {
        if (typeof customToastFunc === 'function') {
          customToastFunc();
        }
        this.getNote();
      });
    },

    // 点击修音偏好设置确认按钮
    handleClickNoteConfirmBtn() {
      this.popupNote = false;
    },

    changeOptionalService(checked) {
      trackElClickH5(`下单页-加急-${checked ? '开' : '关'}`, { product_id: this.productId });
    },

    showCouponPopup() {
      if (this.couponUsable < 1) {
        return;
      }

      if (this.selectedTopic.id) {
        this.$dialog.alert({
          message: '活动与优惠劵不可叠加使用，取消活动后可使用'
        });

        return;
      }

      this.popupCoupon = true;
    },

    async useCoupon(item) {
      if (item.can_use != 1) {
        return;
      }

      if (this.selectedCoupon.id === item.id) {
        this.selectedCoupon = {};
        this.basePrice = this.detail.now_money;

        this.popupCoupon = false;

        return;
      }

      this.selectedCoupon = { ...item };

      await this.getMoney();

      this.popupCoupon = false;
    },

    async getMoney() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicService/musicmall/getProductPriceByCoupon', {
        data: {
          productid: this.productId,
          couponid: this.selectedCoupon.id
        }
      });

      this.$toast.clear();

      if (code === 1) {
        this.basePrice = data.price;
      }
    },

    openProductPicker() {
      this.productPicker = true;

      // 解决 loading 被 popup 盖住的问题（后弹出的永远会遮住先弹出的）
      this.$nextTick(() => {
        this.getProducts();
      });
    },

    // async getSellers() {
    //   if (this.producersList.length) {
    //     return;
    //   }

    //   const { code, data } = await this.$fetch('/api/musicService/musicmall/getuserorder', {
    //     data: {
    //       productid: this.productId
    //     }
    //   });

    //   if (code === 1) {
    //     this.producersList = data;
    //   }
    // },

    openProducer() {
      // 首单不能指定制作师，次单享受指定制作师的权益
      if (!this.showProducer) {
        return;
      }
      this.popupProducer = true;

      // 解决 loading 被 popup 盖住的问题（后弹出的永远会遮住先弹出的）
      // this.$nextTick(() => {
      //   this.getSellers();
      // });
    },

    // 选择制作师（修音师）
    selectProducer(item) {
      if (this.selectedProducer.producerid === item.producerid) {
        // 再次点击则取消
        this.selectedProducer = {};

        this.popupProducer = false;

        return;
      }

      this.selectedProducer = { ...item };

      this.popupProducer = false;
    },

    async getTopics() {
      const { code, data } = await this.$fetch('/api/musicService/musicmall/getactivitypriceList', {
        data: {
          productid: this.productId,
          magicParam: this.$macaddress
        }
      });

      if (code === 1) {
        this.topics = data;
        this.topicActions = [...this.topics];
        this.topicActions.push({
          id: 0,
          name: '不参加任何活动'
        });

        this.topicUsable = this.topics.length > 0;

        if (this.topicUsable) {
          this.selectedTopic = { ...this.topics[0] };
          this.topicActions[0].className = 'selected';

          this.basePrice = Number(this.selectedTopic.activity_money);
        }
      }
    },

    showTopicPopup() {
      if (!this.topicUsable) {
        return;
      }

      if (this.selectedCoupon.id) {
        this.$dialog.alert({
          message: '活动与优惠劵不可叠加使用，取消优惠券后可使用'
        });

        return;
      }

      this.popupTopic = true;
    },

    useTopic(action, index) {
      this.topicActions.forEach(item => item.className = '');
      this.topicActions[index].className = 'selected';

      // 选择不参加活动
      if (action.id === 0) {
        this.selectedTopic = {};
        this.basePrice = this.detail.now_money;

        this.popupTopic = false;

        return;
      }

      this.selectedTopic = { ...action };

      this.basePrice = Number(this.selectedTopic.activity_money);

      this.popupTopic = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@cdn_js/styles/buy.scss";

.payment li {
  &:first-child {
    margin-top: 0;
  }
}

.optional-service {

  .action {
    text-align: right;
  }

  .extra-option {
    position: relative;
    padding-top: 22px;

    .mall-switch {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}

.flex-betweent-start {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;

  .flex-right {
    .action {
      text-align: right;

      span {
        color: #aaa;
        font-size: 14px;
      }
    }
  }

  .extra-desc {
    margin-top: 6px;
    font-size: 12px;
    color: #aaa;

    &.no-margin {
      margin: 0;
    }

    p {
      line-height: 1.4;
      text-align: right;
    }
  }

  .ft {
    text-align: right;
  }
}

.producer-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &-avatar {
    margin-right: 15px;

    img {
      width: 56px;
      height: 56px;
      border-radius: 56px;
    }
  }

  &-info {
    flex: 1;
    text-align: left;
    font-family: PingFang SC-Medium, PingFang SC;

    .producer-item-name {
      font-size: 15px;
      font-weight: 500;
      color: #000;
      line-height: 22px;
    }

    .producer-item-desc {
      color: #aaa;
      font-size: 13px;
      line-height: 20px;
    }
  }

  &-btn {
    width: 80px;
    height: 34px;
    border-radius: 20px;
    border: 1px solid #ff3348;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ff3348;
    line-height: 34px;
    text-align: center;
  }
}

.van-toast::v-deep {
  z-index: 2099 !important;
}

.wrapper {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);

  .block {
    height: 60vh;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
